export default {"src":"/_next/static/media/logo.a0ff3237.svg","height":33,"width":236};